import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import React from 'react'

const MultiValueCellWithTooltip = ({ value }: { value: string[] }) => (
    <TooltipEllipsis text={value?.join(', ') ?? ''}>
        <Typography
            style={{ fontSize: pxToRem(14), fontFamily: 'Roboto' }}
            noWrap
        >
            {value?.join(', ')}
        </Typography>
    </TooltipEllipsis>
)
export default MultiValueCellWithTooltip
